import Vue from 'vue'
import Router from 'vue-router'
import Top from "../components/Top";
import Analytics from "../components/Analytics";
import AchievementList from "../components/AchievementList";
import Contact from "../components/Contact";
import Kamehameha from "../components/contents-page/Kamehameha";
import Jogging from "../components/contents-page/Jogging";
import YoutubeJogging from "../components/contents-page/YoutubeJogging";
import ReiGun from "../components/contents-page/ReiGun";
import ShuttleRun from "../components/contents-page/ShuttleRun";
import Seiken from "../components/contents-page/Seiken";
import Crunch from "../components/contents-page/Crunch";
import Mustang from "../components/contents-page/Mustang";
import Squat from "../components/contents-page/Squat";
import DumbbellCurl from "../components/contents-page/DumbbellCurl";

Vue.use(Router)

export default new Router({
  mode: 'history',
  // ルート追加
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: Analytics
    },
    {
      path: '/achievements',
      name: 'AchievementList',
      component: AchievementList
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/kamehameha',
      name: 'Kamehameha',
      component: Kamehameha
    },
    {
      path: '/jogging',
      name: 'Jogging',
      component: Jogging
    },
    {
      path: '/youtube-jogging',
      name: 'YoutubeJogging',
      component: YoutubeJogging
    },
    {
      path: '/rei-gun',
      name: 'ReiGun',
      component: ReiGun
    },
    {
      path: '/shuttle-run',
      name: 'ShuttleRun',
      component: ShuttleRun
    },
    {
      path: '/seiken',
      name: 'Seiken',
      component: Seiken
    },
    {
      path: "/crunch",
      name: 'Crunch',
      component: Crunch
    },
    {
      path:  "/mustang",
      name: 'Mustang',
      component: Mustang
    },
    {
      path: "/dumbbell-curl",
      name: 'DumbbellCurl',
      component: DumbbellCurl
    },
    {
      path: "/squat",
      name: 'Squat',
      component: Squat
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js